module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h4', {
    staticClass: "hilight-color mg-clear"
  }, [_c('span', {
    staticClass: "ion ion-information-circled"
  }), _vm._v(" "), _vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(_vm.type == 'files') ? void 0 : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-e13ef7da"}!./src/app/components/section-header/section-header.html
// module id = 501
// module chunks = 1